<template functional>
  <div
    :style="props.background ? `background-color: ${props.background}` : ''"
    class="video-result"
  >
    <div class="video-result__duration">
      <p class="data">{{ props.video.duration }}</p>
    </div>
    <div class="video-result__title">
      <p class="data">{{ props.video.title }}</p>
    </div>
    <div class="video-result__btn-wrapper">
      <button
        @click="listeners['click:openVideo']({ video: props.video })"
        class="btn__action"
      >
        PLAY VIDEO
        <span class="material-icons btn__action-icon">play_circle_filled</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoSearchResult',
  props: {
    video: {
      type: Object,
      required: true,
    },
    background: {
      type: String,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.video-result {
  width: 100%;
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding: 15px 5px;
  &__duration {
    width: 15%;
  }
  &__title {
    flex-grow: 1;
    width: 60%;
    padding: 0 10px;
  }
  &__btn-wrapper {
    @include tablet {
      width: 25%;
    }
  }
}
</style>
